import React from 'react';
import Link, { LinkProps } from 'next/link';
import { UrlObject } from 'url';

import { useAppSelector } from 'redux/store';
import { createValidURL } from 'utils/url';
import { DocReader } from 'components/docreader/docreader';

export interface INextLinkProps extends Omit<LinkProps, 'href'> {
	id?: string;
	href?: string | UrlObject;
	children?: any;
}

export const NextLink = ({ href = '#', children, ...rest }: INextLinkProps): React.JSX.Element => {
	const { publicationState } = useAppSelector((state) => state.settings);

	// Don't prefetch in preview mode to prevent performance issues
	if (!rest.prefetch && publicationState === 'DRAFT') {
		rest.prefetch = false;
	}

	// Process URL directly without state to avoid hydration mismatch
	const processedUrl = React.useMemo(() => {
		if (href && typeof href === 'string') {
			return createValidURL(href);
		} else if (href && typeof href === 'object') {
			return { ...href, pathname: createValidURL((href as UrlObject).pathname || '#') };
		}
		return href;
	}, [href]);

	return (
		<>
			<Link {...rest} locale={false} href={processedUrl || '/'}>
				{children}
			</Link>
			<DocReader url={processedUrl?.toString()} />
		</>
	);
};

export default NextLink;
